
import { defineComponent } from "vue";
import HyphenParagraph from "common/src/components/HyphenParagraph.vue";
import { getGenderText } from "common/src/utils/codes";

export default defineComponent({
  components: {
    HyphenParagraph,
  },
  props: {
    /** 被保険者番号 */
    tf_khhkno: {
      type: String,
      required: true,
    },
    /** 被保険者名漢字 */
    tf_khhksj: {
      type: String,
      required: true,
    },
    /** 被保険者名カナ */
    tf_khhksk: {
      type: String,
      required: true,
    },
    /** 被保険者生年月日 */
    tf_khhkbt: {
      type: String,
      required: true,
    },
    /** 被保険者性別 */
    tf_khhksx: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const insuredNum = Number.parseInt(props.tf_khhkno);

    return {
      insuredNum,
      props,
      getGenderText,
    };
  },
});
